export default "__VITE_ASSET__BjduzYDy__"